import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { graphqlRequest } from "context/graphql/functions";
import { GetMachinesQueryVariables } from "operations/schema/schema";
import { AppAsyncThunkConfig } from "store";
import { State } from "./machine.store";

export const createAppAsyncThunk = createAsyncThunk.withTypes<AppAsyncThunkConfig>();

export const asyncQueries = {
  getMachines: createAppAsyncThunk(
    "machineAutocomplete/getMachines",
    async (variables: GetMachinesQueryVariables, { rejectWithValue, extra: { sdk } }) => {
      const { data, errors } = await graphqlRequest(sdk.getMachines, { variables });
      if (errors) return rejectWithValue(errors);
      if (!data?.machines) return rejectWithValue("something went wrong");
      return data.machines;
    },
  ),
};

export const queryBuilder = (builder: ActionReducerMapBuilder<State>) => {
  builder.addCase(asyncQueries.getMachines.pending, (state) => {
    state.machinesLoading = true;
  });
  builder.addCase(asyncQueries.getMachines.rejected, (state, { payload: errors }) => {
    state.machinesLoading = false;
    state.errors = errors;
  });
  builder.addCase(asyncQueries.getMachines.fulfilled, (state, { payload: machines }) => {
    state.machinesLoading = false;
    state.machines = [...machines];
    return state;
  });
};
